import loginRoutes from '../containers/Login';
import settingsRoutes from '../containers/Settings';
import contentRoutes from '../containers/Content';
import productsRoutes from '../containers/Products';
import blockRendererRoutes from '../containers/BlockRendererTemplates';

const routes = [...loginRoutes, ...settingsRoutes, ...contentRoutes, ...productsRoutes, ...blockRendererRoutes];

export default routes;
